module.exports = __webpack_public_path__ + "static/img/a064.5d8a2f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a064.jpg
// module id = lWFj
// module chunks = 0